const GET_EMAILS_REQUEST = "GET_EMAILS_REQUEST";
const GET_EMAILS_REQUEST_SUCCESS = "GET_EMAILS_REQUEST_SUCCESS";
const GET_EMAILS_REQUEST_FAILURE = "GET_EMAILS_REQUEST_FAILURE";

const PATCH_EMAILS_REQUEST = "PATCH_EMAILS_REQUEST";
const PATCH_EMAILS_REQUEST_SUCCESS = "PATCH_EMAILS_REQUEST_SUCCESS";
const PATCH_EMAILS_REQUEST_FAILURE = "PATCH_EMAILS_REQUEST_FAILURE";

export {
  GET_EMAILS_REQUEST,
  GET_EMAILS_REQUEST_SUCCESS,
  GET_EMAILS_REQUEST_FAILURE,
  PATCH_EMAILS_REQUEST,
  PATCH_EMAILS_REQUEST_SUCCESS,
  PATCH_EMAILS_REQUEST_FAILURE,
};
